import React, { useState } from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core'
import { dinamicTablesStyles } from './styles';

const TableModules = ({ info, modules, groupData }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const classes = dinamicTablesStyles()

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Box className={classes.container}>
      <h3 className={classes.title}>Número de acciones por módulo según tipo</h3>
      <TableContainer>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell colSpan={3} style={{ color: '#F6F6F6' }}>Empty</TableCell>
              {modules.map(module => (
                <TableCell colSpan={2} align='center'>{module}</TableCell>
              ))}
            </TableRow>
            <TableRow className={classes.rowHead}>
              <TableCell>Gerente</TableCell>
              <TableCell>Jefe</TableCell>
              <TableCell>Socio</TableCell>
              {modules.map(() => (
                <>
                  <TableCell style={{color: '#F5CD26'}}>Tácticas</TableCell>
                  <TableCell style={{color: '#F68907'}}>Estratégicas</TableCell>
                </>
            ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {groupData(info, 'socio').map(partner => (
              <TableRow>
                <TableCell>{partner[0].gerente}</TableCell>
                <TableCell>{partner[0].jefe}</TableCell>
                <TableCell style={{color: '#2699FB'}}>{partner[0].socio}</TableCell>
                {modules.map(module => (
                  <>
                    <TableCell>{partner.filter(action => action.modulo === module && action.tipo === 'Tácticas')[0]?.total || '0'}</TableCell>
                  {/* <TableCell>{modulesFromActions.includes(module) ? partner.map(action => (action.modulo === module && action.tipo === 'Tácticas') && action.total) : '0'}</TableCell> */}
                  {/* <TableCell>{modulesFromActions.includes(module) ? partner.map(action => (action.modulo === module && action.tipo === 'Estrátegicas') && action.total) : '0'}</TableCell> */}
                    <TableCell>{partner.filter(action => action.modulo === module && action.tipo === '0')[0]?.total || '0'}</TableCell>
                  </>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={groupData(info, 'socio').length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default TableModules